/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, Feb 2023
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classes from './MergeTableLookup.module.css';
import strings from '../../../../globalization';
import Whiteboard from '../../../Playground/components/Body/Whiteboard';
import { toast } from 'react-toastify';

const MergeTableLookup = ({ onClosePopup, shapes, onMergeTable, selectedShape, selectedCheck, onMoveTable }) => {
  const [updatedShapes, setUpdatedShapes] = useState(new Map());
  useEffect(() => {
    const allShapes = Array.isArray(shapes) ? shapes : [];
    let copiedShapes = new Map(shapes);
    allShapes.forEach(shape => {
      copiedShapes.set(shape.id, shape);
      //   if (selectedShape.moveTableFlow) {
      //     if (shape.stationId === selectedShape.stationId || shape.occupied) {
      //       copiedShapes.set(shape.id, {
      //         ...shape,
      //         stroke: 'grey',
      //       });
      //     } else {
      //       copiedShapes.set(shape.id, {
      //         ...shape,
      //         stroke: 'white',
      //       });
      //     }
      //   } else {
      //     if (shape.stationId === selectedShape.stationId || shape.parentStationId || (shape.mergedStationIds && shape.mergedStationIds.length > 0)) {
      //       copiedShapes.set(shape.id, {
      //         ...shape,
      //         stroke: 'grey',
      //       });
      //     } else {
      //       copiedShapes.set(shape.id, {
      //         ...shape,
      //         stroke: 'white',
      //       });
      //     }
      //   }
    });
    setUpdatedShapes(copiedShapes);
  }, [shapes]);

  const onSelectShape = (shape) => {
    if (shape?.stationId) {
      if (selectedShape.moveTableFlow) {
        if (shape.stationId === selectedShape.stationId) {
          toast.warning(strings.selectedStationToast, { autoClose: 1000 });
        } else if (shape.occupied) {
          toast.warning(strings.table + ` ${shape.stationNumber} ` + strings.anotherTableSelect, { autoClose: 1000 });
        } else {
          onMoveTable && onMoveTable(selectedShape.stationNumber, shape.stationNumber, shape.stationId, selectedCheck);
        }
      } else {
        if (shape.stationId === selectedShape.stationId) {
          toast.warning(strings.selectedStationMergeToast, { autoClose: 1000 });
        } else if (shape.parentStationId || (shape.mergedStationIds && shape.mergedStationIds.length > 0)) {
          toast.warning(strings.table + ` ${shape.stationNumber} ` + strings.alreadyMerged, { autoClose: 1000 });
        } else {
          onMergeTable && onMergeTable(selectedShape.stationId, shape.stationId, shape.stationNumber);
        }
      }
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerWrapper}>
        <div className={classes.headerTxt}>{selectedShape.moveTableFlow ? strings.selectTableToMove : strings.selectTableToMerge}</div>
        <div className={classes.closeBtn} onClick={onClosePopup}>X</div>
      </div>
      <div className={classes.bodyWrapper}>
        <Whiteboard
          shapes={updatedShapes}
          draggable={false}
          selectShape={onSelectShape}
          tableInfoColumn='stationNumber'
          height={'94vh'}
          backgroundColor={'#3a3a3a'}
          stageContainerBackgroundColor={'#3a3a3a'}
        />
      </div>
    </div>
  );
};

export default MergeTableLookup;

MergeTableLookup.propTypes = {
  onClosePopup: PropTypes.func,
  shapes: PropTypes.array
};

MergeTableLookup.defaultProps = {
  onClosePopup: () => { },
  shapes: [],
};
